<!--=================================
=            PAGES EMPTY            =
==================================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Page Empty</div>
      </base-header>
    </v-row>
    <v-row> <div style="height:750px"></div>
    
    </v-row>
   
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    
  }
</script>


<!--====  End of PAGES EMPTY  ====-->
